import { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import Button from '../components/common/Button';
import Modal from '../components/common/Modal';

export default function Planos() {
  const { usuario } = useAuth();
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Hero */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Plano Pro
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Tudo que você precisa para vender seus animais com destaque
          </p>
        </div>

        {/* Plano Pro Card */}
        <div className="max-w-lg mx-auto">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden ring-2 ring-green-500">
            <div className="bg-green-500 text-white text-center py-2 text-sm font-medium">
              ⭐ Plano Recomendado
            </div>
            
            <div className="p-8">
              <div className="text-center mb-6">
                <h3 className="text-3xl font-bold text-gray-900 mb-2">
                  Pro
                </h3>
                <p className="text-gray-500">Para vendedores que querem resultados</p>
              </div>
              
              <div className="text-center mb-8">
                <span className="text-5xl font-bold text-gray-900">
                  R$ 99
                </span>
                <span className="text-gray-500">/mês</span>
              </div>

              <Button
                onClick={() => setShowPaymentModal(true)}
                variant="primary"
                className="w-full py-4 text-lg mb-8"
              >
                {usuario?.plano ? 'Plano Atual ✓' : 'Começar Agora'}
              </Button>

              <div className="space-y-4">
                <h4 className="font-semibold text-gray-900">O que está incluso:</h4>
                <ul className="space-y-3">
                  {[
                    'Anúncios ilimitados',
                    '1 destaque automático por mês',
                    'Fotos em alta resolução (até 20 por anúncio)',
                    'Vídeos do YouTube/Vimeo',
                    'Dashboard com analytics',
                    'Chat direto com compradores',
                    'Suporte por email',
                    'Badge "Vendedor Pro" no perfil',
                    'Relatórios mensais de desempenho',
                    'Notificações de novas ofertas'
                  ].map((recurso, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <span className="text-green-500 text-xl">✓</span>
                      <span className="text-gray-600">{recurso}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Garantia */}
        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-2 bg-green-50 text-green-700 px-6 py-3 rounded-full">
            <span className="text-2xl">🛡️</span>
            <span className="font-medium">Garantia de 7 dias - Cancele quando quiser</span>
          </div>
        </div>

        {/* FAQ Simples */}
        <div className="mt-16 bg-white rounded-2xl shadow-lg p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">
            Perguntas Frequentes
          </h2>
          
          <div className="space-y-6 max-w-2xl mx-auto">
            <FaqItem 
              question="Posso cancelar a qualquer momento?"
              answer="Sim! Você pode cancelar sua assinatura quando quiser. O acesso continua até o fim do período pago."
            />
            <FaqItem 
              question="Como funciona o destaque?"
              answer="Todo mês você recebe 1 destaque grátis. Anúncios destacados aparecem no topo das buscas e na homepage, aumentando muito a visibilidade."
            />
            <FaqItem 
              question="Quais formas de pagamento?"
              answer="Aceitamos cartão de crédito, Pix e boleto bancário. Pagamento seguro via Stripe."
            />
            <FaqItem 
              question="E se eu precisar de mais destaques?"
              answer="Você pode comprar destaques avulsos a qualquer momento por R$ 29,90 cada."
            />
          </div>
        </div>

        {/* CTA Final */}
        <div className="mt-16 text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            Pronto para vender mais?
          </h3>
          <p className="text-gray-600 mb-6">
            Junte-se a milhares de criadores que já vendem no BOILX
          </p>
          <Button
            onClick={() => setShowPaymentModal(true)}
            variant="primary"
            className="px-12 py-4 text-lg"
          >
            Assinar Plano Pro - R$ 99/mês
          </Button>
        </div>
      </main>

      <Footer />

      {/* Payment Modal */}
      <Modal
        isOpen={showPaymentModal}
        onClose={() => setShowPaymentModal(false)}
        title="Assinar Plano Pro"
      >
        <div className="p-6">
          <div className="text-center mb-6">
            <p className="text-3xl font-bold text-gray-900">
              R$ 99/mês
            </p>
            <p className="text-gray-500 mt-1">Cancele quando quiser</p>
          </div>

          <div className="space-y-4 mb-6">
            <button className="w-full p-4 border-2 border-gray-200 rounded-lg hover:border-green-500 transition-colors flex items-center gap-3">
              <span className="text-2xl">💳</span>
              <div className="text-left">
                <span className="font-medium block">Cartão de Crédito</span>
                <span className="text-sm text-gray-500">Visa, Master, Elo, Amex</span>
              </div>
            </button>
            <button className="w-full p-4 border-2 border-gray-200 rounded-lg hover:border-green-500 transition-colors flex items-center gap-3">
              <span className="text-2xl">📱</span>
              <div className="text-left">
                <span className="font-medium block">Pix</span>
                <span className="text-sm text-gray-500">Aprovação instantânea</span>
              </div>
            </button>
            <button className="w-full p-4 border-2 border-gray-200 rounded-lg hover:border-green-500 transition-colors flex items-center gap-3">
              <span className="text-2xl">📄</span>
              <div className="text-left">
                <span className="font-medium block">Boleto Bancário</span>
                <span className="text-sm text-gray-500">Vence em 3 dias úteis</span>
              </div>
            </button>
          </div>

          <div className="flex items-center justify-center gap-2 text-sm text-gray-500">
            <span>🔒</span>
            <span>Pagamento seguro processado por Stripe</span>
          </div>
        </div>
      </Modal>
    </div>
  );
}

function FaqItem({ question, answer }: { question: string; answer: string }) {
  const [isOpen, setIsOpen] = useState(false);
  
  return (
    <div className="border-b border-gray-200 pb-4">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full text-left flex justify-between items-center py-2"
      >
        <span className="font-medium text-gray-900">{question}</span>
        <span className="text-green-500 text-xl">{isOpen ? '−' : '+'}</span>
      </button>
      {isOpen && (
        <p className="text-gray-600 mt-2 pl-0">
          {answer}
        </p>
      )}
    </div>
  );
}
